<template>
  <div data-sentry-unmask>
    <div class="flex flex-col gap-2">
      <div v-if="lostFocus" class="flex flex-col items-center justify-center gap-2 md:flex md:flex-row">
        <span>{{ t("ngp/load_error/manual_refresh") }}</span>
        <gp-btn :label="t('ngp/load_error/button/refresh')" :icon="faRefresh" size="small" @click="refresh()"></gp-btn>
      </div>
      <p v-else-if="willRetry">
        <translation keypath="ngp/load_error/error/retry">
          <template #retryTimeout
            ><span class="bg-gp-charcoal-grey whitespace-nowrap px-1 py-0.5 text-base">{{
              humanTimeToRetry
            }}</span></template
          >
        </translation>
        <translation v-if="retryCount > 5" keypath="ngp/load_error/contact_support/text">
          <template #contactSupport>
            <a :href="supportNewTicketUrl" class="underline" target="_blank">{{
              t("ngp/load_error/contact_support")
            }}</a>
          </template>
        </translation>
      </p>
      <div class="font-bold" v-if="isAdmin">
        {{ t("ngp/load_error/error/detailed") }}
      </div>
      <div>
        <div class="bg-gp-black text-gp-mouse mt-1 p-2 font-mono text-xs" v-if="isAdmin">
          <div class="break-words" v-if="ctxError.message">{{ ctxError.message }}</div>
          <div v-for="(error, i) in ctxError.errors" :key="i" class="mt-1">
            <div v-if="error.path">Path: /{{ error.path.join("/") }}</div>
            <div class="break-words">{{ error.message }}</div>
          </div>
        </div>
        <div v-else>
          <translation :keypath="uiErrorI18nKeyPath">
            <template #contactSupport>
              <a :href="supportNewTicketUrl" class="underline" target="_blank">{{
                t("ngp/load_error/contact_support")
              }}</a>
            </template>
          </translation>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { faRefresh } from "@fortawesome/pro-solid-svg-icons";
import { GpBtn } from "@gportal/uikit";
import { computed } from "vue";
import { Translation, useI18n } from "vue-i18n";
import { useClientStore } from "@/store/client";
import { CtxLoadError, useServiceStore } from "@/store/service";
import { uiErrorI18nKeyPath } from "@/util/error";
import { useTime } from "@/util/time";
import { useWiUtils } from "@/util/webinterface";
import { usePermissions } from "@/util/permissions";

const { t } = useI18n();
const service = useServiceStore();
const client = useClientStore();
const { supportNewTicketUrl } = useWiUtils();
const { humanDuration } = useTime();
const { isAdmin } = usePermissions();

const retryCount = computed(() => service.ctxRetry.count);
const ctxError = computed<CtxLoadError | undefined>(() => service.ctxLoadError);
const systemLoaded = computed(() => service.ctx.sys);
const willRetry = computed(() => service.ctxRetry && service.ctxRetry.nextAt > 0);
const timeToRetry = computed(() => {
  if (service.ctxRetry && service.ctxRetry.nextAt > 0) {
    return service.ctxRetry.nextAt - client.clientTime;
  }

  return undefined;
});
const humanTimeToRetry = computed(() => (timeToRetry.value ? humanDuration(timeToRetry.value) : undefined));
const lostFocus = computed(() => service.lostFocus);

function refresh() {
  location.reload();
}
</script>
